export const comments_5256813 = {"data":{"data":[],"links":{}}}